export default __webpack_public_path__ + "static/media/main_section5.c86f731c.jpg";